import { Dumbbell, Loader2 } from "lucide-react"

const LoadingScreen = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center">
      <div className="text-center">
        <div className="relative mb-8">
          <div className="w-24 h-24 bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 rounded-3xl flex items-center justify-center shadow-2xl">
            <Dumbbell className="w-12 h-12 text-white animate-bounce" />
          </div>
          <div className="absolute -top-2 -right-2">
            <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
              <Loader2 className="w-5 h-5 text-white animate-spin" />
            </div>
          </div>
        </div>
        <h2 className="text-3xl font-bold text-gray-800 mb-3">Metabuddy AI</h2>
        <p className="text-gray-600 text-lg mb-6">Powering up your fitness journey...</p>
        <div className="flex justify-center">
          <div className="flex space-x-2">
            <div className="w-3 h-3 bg-blue-500 rounded-full animate-pulse"></div>
            <div className="w-3 h-3 bg-indigo-500 rounded-full animate-pulse" style={{ animationDelay: "0.2s" }}></div>
            <div className="w-3 h-3 bg-purple-500 rounded-full animate-pulse" style={{ animationDelay: "0.4s" }}></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoadingScreen
